import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19.6923" cy="19.7499" r="19.6923" fill={fill} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 21.8076C21.3807 21.8076 22.5 20.6883 22.5 19.3076C22.5 17.9269 21.3807 16.8076 20 16.8076C18.6193 16.8076 17.5 17.9269 17.5 19.3076C17.5 20.6883 18.6193 21.8076 20 21.8076Z"
                stroke={stroke}
                strokeLinecap="square"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M27.5 20.3076V18.3076L25.323 17.9446C25.192 17.4326 24.991 16.9506 24.728 16.5076L26.011 14.7116L24.596 13.2976L22.8 14.5796C22.357 14.3166 21.875 14.1156 21.363 13.9846L21 11.8076H19L18.637 13.9846C18.125 14.1156 17.643 14.3166 17.2 14.5796L15.404 13.2976L13.99 14.7116L15.272 16.5076C15.009 16.9506 14.808 17.4326 14.677 17.9446L12.5 18.3076V20.3076L14.677 20.6706C14.808 21.1826 15.009 21.6646 15.272 22.1076L13.99 23.9036L15.404 25.3176L17.2 24.0356C17.643 24.2986 18.125 24.4996 18.637 24.6306L19 26.8076H21L21.363 24.6306C21.875 24.4996 22.357 24.2986 22.8 24.0356L24.596 25.3186L26.01 23.9046L24.728 22.1076C24.991 21.6646 25.192 21.1826 25.323 20.6706L27.5 20.3076Z"
                stroke={stroke}
                strokeLinecap="square"
            />
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
            <path
                d="M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z"
                stroke={stroke}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5 9V7L13.323 6.637C13.192 6.125 12.991 5.643 12.728 5.2L14.011 3.404L12.596 1.99L10.8 3.272C10.357 3.009 9.875 2.808 9.363 2.677L9 0.5H7L6.637 2.677C6.125 2.808 5.643 3.009 5.2 3.272L3.404 1.99L1.99 3.404L3.272 5.2C3.009 5.643 2.808 6.125 2.677 6.637L0.5 7V9L2.677 9.363C2.808 9.875 3.009 10.357 3.272 10.8L1.99 12.596L3.404 14.01L5.2 12.728C5.643 12.991 6.125 13.192 6.637 13.323L7 15.5H9L9.363 13.323C9.875 13.192 10.357 12.991 10.8 12.728L12.596 14.011L14.01 12.597L12.728 10.8C12.991 10.357 13.192 9.875 13.323 9.363L15.5 9Z"
                stroke={stroke}
                strokeLinecap="square"
            />
        </svg>
    );
};

const MenuAccountSettings = ({isActive = false}) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuAccountSettings.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuAccountSettings;
